import {
  UpdateType
} from '../const';

export class Search {

  constructor(container) {
    this._elem = container.querySelector('.control__input--search');
  }


  search(list) {
    const regexp = new RegExp(this._elem.value, 'ig');
    const strings = list.querySelectorAll('.control__label span');

    strings.forEach((str) => {
      const text = str.textContent;
      const parent = str.closest('.block-filter__item');
      return text.match(regexp) ? parent.classList.remove('hide') : parent.classList.add('hide');
    });
  }

  searchAjax(callback) {
    callback(UpdateType.LIGHT);
  }

  clear() {
    if (this._elem) {
      this._elem.value = '';
    }
  }

  focus() {
    if (this._elem) {
      this._elem.focus();
      this._elem.placeholder = 'Ищите здесь';
      this._elem.classList.add('control__input--shake');
      setTimeout(() => {
        this._elem.classList.remove('control__input--shake');
      }, 500);
    }
  }
}
